/**
 * Part of datavideo project.
 *
 * @copyright  Copyright (C) 2021 ${ORGANIZATION}.
 * @license    __LICENSE__
 */

import '@sweetalert';
import Unicorn from '@main';

window.alert = swal;

u.formValidation();

$(() => {
  const subscribeBtn = $('.subscribe-form .submit');
  const loading = $('.subscribe-form .submit .spinner-border');
  const input = $('.subscribe-form input');
  const download = $('.download-link');
  const subscribeForm = $('.subscribe-form');

  subscribeBtn.prop('disabled', false);
  subscribeForm.submit(false);

  subscribeBtn.on('click', async function (event) {
    event.stopPropagation();
    const $btn = $(event.currentTarget);
    const $form = subscribeForm;

    const router = $btn.attr('data-url');

    loading.removeClass('d-none');
    subscribeBtn.prop('disabled', true);

    try {
      const res = await u.$http.post(
        router,
        new FormData($form[0])
      );

      await swal({
        title: res.data.data.type.toUpperCase(),
        icon: res.data.data.type,
        text: res.data.data.message,
      });

      if (res.data.data.type !== 'error') {
        window.open(download.val(), '_blank');
      }

      sendingFinish();
    } catch (e) {
      sendingFinish();
      console.error(e);
    }
  })

  function sendingFinish() {
    subscribeBtn.prop('disabled', false);
    loading.addClass('d-none');
    input.val('');
  }
});
